import clsx from "clsx";
import type React from "react";
import type { ComponentProps, ReactNode } from "react";
import { DealLayoutHeaderClient } from "~/components/common/layouts/deals/DealLayoutHeaderClient";
import type { Deal } from "~/models/Deal";
import Styles from "./DealLayout.module.scss";
import { DealLayoutHeaderVendor } from "./DealLayoutHeaderVendor";

type Props = {
	children: ReactNode;
	deal: Deal;
	isVendor?: boolean;
	items: ComponentProps<
		typeof DealLayoutHeaderVendor | typeof DealLayoutHeaderClient
	>["items"];
	noBackground?: boolean;
	useSimpleSpHeader?: boolean;
};

export const DealLayout: React.FC<Props> = ({
	deal,
	children,
	items,
	noBackground = false,
	isVendor = false,
	useSimpleSpHeader = false
}: Props) => (
	<div>
		{isVendor ? (
			<DealLayoutHeaderVendor
				deal={deal}
				items={items}
				useSimpleSpHeader={useSimpleSpHeader}
			/>
		) : (
			<DealLayoutHeaderClient
				deal={deal}
				items={items}
				useSimpleSpHeader={useSimpleSpHeader}
			/>
		)}
		<div
			className={clsx(
				Styles.Container,
				noBackground ? Styles.Transparent : Styles.White
			)}
		>
			{children}
		</div>
	</div>
);
